import { FilePlusArrayBase } from '../FilePlusArrayBase';

export class ZipCodes extends FilePlusArrayBase {
  static arrayField = 'zipCodes';
  zipCodes = null;
}
